
import config from './config';
import 'whatwg-fetch';

// #####################################################################################################################
// Fonctions util

function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response
    } else {

        var error = new Error(response.statusText);

        return parseJSON(response)
            .then(function(res){
                error.response = res;
                throw error
            })
            .catch(function(err){
                throw error
            })

    }
}

function parseJSON(response) {
    return response.json()
}

// #####################################################################################################################
// Headers
const defaultHeader = {
    "Accept-Encoding": "gzip, deflate, sdch, br",
    "Accept-Language": "fr-FR,fr;q=0.8,en-US;q=0.6,en;q=0.4",
    "Accept": "application/json, text/plain, */*",
    "Origin" : "*",
    "X-Requested-With" : "you",
    "Content-Type": "json",
    "Authorization": "none"
};

// "useXDomain" : true,
// #####################################################################################################################

// ---------------------------------------------------------------------------------------------------------------------
// récupération des listes d'adresses associé à une recherche d'adresse
async function getBanAdress(adress) {

    // var prioriteGeo ="&lat=48.857441&lon=2.347652&autocomplete=1&limit=10";
    var prioriteGeo ="&citycode=75056&autocomplete=1&limit=10";

    return new Promise(function(resolve, reject) {

        if (!adress || adress== ''){
            return resolve([]);
        }

        fetch(config.server.ban + '/?q=' + adress + prioriteGeo, {method : 'GET'})
            .then(checkStatus)
            .then(parseJSON)
            .then(function(data) {
                // console.log('request succeeded with JSON response', data)
                try{
                    if (data.features.length<5){
                        getBanAdressWithGeoPrio(adress)
                            .then(function(res){
                                resolve(res)
                            })
                            .catch(function(err) {
                                console.log('request failed', err);
                                reject(err);
                            })
                    }
                    else {
                        // Handle data if needed.
                        resolve( data.features.map(function(item){return {lib : item.properties.label, coord: item.geometry.coordinates};}));
                        // resolve(data);
                    }
                }
                catch(err){
                    reject(err);
                }

            })
            .catch(function(err) {
                console.log('request failed', err);
                reject(err);
            })


    })

}

// ---------------------------------------------------------------------------------------------------------------------
// récupération des listes de station metro / tram RER pour une recherche
async function searchTransportStation(adress) {

    function treatLines(lines){

        // var data = lines.replace("'", '"');
        // var data = lines.replace(/'+/g, " ");
        var data = lines.replace(/'/g, '"');
        data = JSON.parse(data);

        var metro = [];
        var rer = [];
        var tram = [];
        var train = [];

        for (var i = 0; i < data.length;  i++){
            if (data[i].type === 'Metro'){
                metro.push(data[i])
            } else if (data[i].type === 'Train'){
                train.push(data[i])
            }
            else if (data[i].type === 'Tramway'){
                tram.push(data[i])
            }
            else if (data[i].type === 'RER'){
                rer.push(data[i])
            }
        }
        return ({metro : metro, rer: rer, tram: tram, train: train});
    }



    return new Promise(function(resolve, reject) {

        if (!adress || adress== ''){
            return resolve([]);
        }
        fetch(config.server.url + '/search/searchstation?place=' + adress, {method : 'GET'})
            .then(checkStatus)
            .then(parseJSON)
            .then(function(data) {
                // Handle data if needed.
                resolve( data.stations.map(function(item){return {lib : item.lib, lines : JSON.parse(item.lignes.replace(/'/g, '"')), coord: item.coordinates};}));

            })
            .catch(function(err) {
                console.log('request failed', err);
                reject(err);
            })
    })

}

// ---------------------------------------------------------------------------------------------------------------------
// récupération des styles pou les stations metro / tram RER pour une recherche
async function getTransportStationStyle() {


    return new Promise(function(resolve, reject) {

        fetch(config.server.url + '/search/stationstyle', {method : 'GET'})
            .then(checkStatus)
            .then(parseJSON)
            .then(function(data) {

                // Handle data if needed.
                resolve(data);
            })
            .catch(function(err) {
                console.log('request failed', err);
                reject(err);
            })
    })

}

// ---------------------------------------------------------------------------------------------------------------------
// récupération des listes d'adresses associé à une recherche d'adresse
async function getBanAdressWithGeoPrio(adress) {

    var prioriteGeo ="&lat=48.857441&lon=2.347652&autocomplete=1&limit=10";
    // var prioriteGeo ="&citycode=75056&autocomplete=1&limit=10";

    return new Promise(function(resolve, reject) {

        if (!adress || adress== ''){
            return resolve([]);
        }
        fetch(config.server.ban + '/?q=' + adress + prioriteGeo, {method : 'GET'})
            .then(checkStatus)
            .then(parseJSON)
            .then(function(data) {
                // console.log('request succeeded with JSON response', data)

                // Handle data if needed.
                resolve( data.features.map(function(item){return {lib : item.properties.label, coord: item.geometry.coordinates};}));
                // resolve(data);
            })
            .catch(function(err) {
                console.log('request failed', err);
                reject(err);
            })
    })

}

// ---------------------------------------------------------------------------------------------------------------------
// récupération des listes d'adresses associé à une recherche d'adresse
async function getBanAdressFromPoint(latlng) {

    return new Promise(function(resolve, reject) {

        // if (!adress || adress== ''){
        //     return resolve([]);
        // }

        fetch(config.server.banReverse + '/?' + 'lon=' + latlng.lng + '&lat=' + latlng.lat, {method : 'GET'})
            .then(checkStatus)
            .then(parseJSON)
            .then(function(data) {
                // console.log('request succeeded with JSON response', data)

                // Handle data if needed.
                resolve(data);
                // resolve(data);
            })
            .catch(function(err) {
                console.log('request failed', err);
                reject(err);
            })


    })

}

// ---------------------------------------------------------------------------------------------------------------------
// récupération d'une serie automatique d'isochrones
async function getIsochronesAuto(query) {

    return new Promise(function(resolve, reject) {

        var cancelAfterTimeOut = setTimeout(function(){reject('timeOut')}, 20000);


        fetch(config.server.url + '/areafinder/isonoparam?' + query, {method : 'GET', headers: defaultHeader})
            .then(checkStatus)
            .then(parseJSON)
            .then(function(data) {
                clearTimeout(cancelAfterTimeOut);
                // Handle data if needed.
                resolve(data);
            })
            .catch(function(err) {
                console.log('request failed', err);
                reject(err);
            })


    })

}

// ---------------------------------------------------------------------------------------------------------------------
// récupération d'une serie définie d'isochrones
async function getIsochronesCustom(query) {

    return new Promise(function(resolve, reject) {

        var cancelAfterTimeOut = setTimeout(function(){reject('timeOut')}, 20000);

        fetch(config.server.url + '/areafinder/isowithparam?' + query, {method : 'GET', headers: defaultHeader})
            .then(checkStatus)
            .then(parseJSON)
            .then(function(data) {

                clearTimeout(cancelAfterTimeOut);
                // Handle data if needed.
                resolve(data);
            })
            .catch(function(err) {
                console.log('request failed', err);
                reject(err);
            })
    })

}

// ---------------------------------------------------------------------------------------------------------------------
// Vérification de la validité d'une adresse
function checklocationvalidity(latlng){

    return new Promise(function(resolve, reject) {
        // fetch('http://localhost:3102 '+ '/areafinder/checklocationvalidity/?' + 'lon=' + latlng.lng + '&lat=' + latlng.lat, {method : 'GET', headers: defaultHeader})
        fetch(config.server.url +  '/areafinder/checklocationvalidity/?' + 'lon=' + latlng.lng + '&lat=' + latlng.lat, {method : 'GET', headers: defaultHeader})
            .then(checkStatus)
            .then(parseJSON)
            .then(function(data) {
                // Handle data if needed.
                resolve(data);
            })
            .catch(function(err) {
                console.log('request failed', err);
                reject(err);
            })
    })
}

// ---------------------------------------------------------------------------------------------------------------------
// Get Metro de la validité d'une adresse
function getMapDataMetro(){

    return new Promise(function(resolve, reject) {
        // fetch('http://localhost:3102'+ '/basemap/hubs', {method : 'GET', headers: defaultHeader})
        fetch(config.server.url +  '/basemap/hubs',{method : 'GET', headers: defaultHeader})
            .then(checkStatus)
            .then(parseJSON)
            .then(function(data) {

                resolve(data);
            })
            .catch(function(err) {
                console.log('request failed', err);
                reject(err);
            })
    })
}

// ---------------------------------------------------------------------------------------------------------------------
// Get transport lines
function getMapDataTransportLines(){

    return new Promise(function(resolve, reject) {
        // fetch('http://localhost:3102'+ '/basemap/hubs', {method : 'GET', headers: defaultHeader})
        fetch(config.server.url +  '/basemap/transportlines',{method : 'GET', headers: defaultHeader})
            .then(checkStatus)
            .then(parseJSON)
            .then(function(data) {
                resolve(data);
            })
            .catch(function(err) {
                console.log('request failed', err);
                reject(err);
            })
    })
}

// =====================================================================================================================
// ========================= Places ====================================================================================

// ---------------------------------------------------------------------------------------------------------------------
// Get transport lines
function getPlacesInBuffer(data){

    return new Promise(function(resolve, reject) {
        // fetch('http://localhost:3102'+ '/basemap/hubs', {method : 'GET', headers: defaultHeader})
        fetch(config.server.url +  '/places/placesinbuf?lat=' + data.lat + '&lon=' + data.lon + '&buf=' + data.buf ,{method : 'GET', headers: defaultHeader})
            .then(checkStatus)
            .then(parseJSON)
            .then(function(data) {
                resolve(data);
            })
            .catch(function(err) {
                console.log('request failed', err);
                reject(err);
            })
    })
}


// ################# EXPORT ############################################################################################
export default { getBanAdress, searchTransportStation, getBanAdressFromPoint, getIsochronesAuto, getIsochronesCustom, checklocationvalidity, getMapDataMetro, getMapDataTransportLines, getTransportStationStyle, getPlacesInBuffer};




// WEBPACK FOOTER //
// ./src/services/rest-service.js